import s from "./highrise1780.mjs";
function h(a, e) {
  var t = s(this, a), i = t.size;
  return t.set(a, e), this.size += t.size == i ? 0 : 1, this;
}
export {
  h as default
};
